module.exports = __webpack_public_path__ + "img/couples-053.4a7ba7e7.jpg";